<template>
    <div
        class="mobile-subnav__item"
        @click="$emit('click')"
    >
        <div class="mobile-subnav__item-wrapper">
            <div class="flex__align-center">
                <i
                    v-if="selectedItem.icon"
                    :class="selectedItem.icon"
                    class="mr-1 icon"
                />
                <FlagIcon
                    v-if="selectedItem.flag"
                    isLarge
                    :flag="`flags/${selectedItem.flag}.png`"
                />
            </div>
            <span class="mobile-subnav__item-text">
                {{ selectedItem.name | upperCase }}
            </span>
        </div>
        <template v-if="isSidebarExpanded">
            <i class="icon--md icon-close"/>
        </template>
        <i v-else class="icon--md icon-filter"/>
    </div>
</template>

<script>
    export default {
        props: {
            selectedItem: {
                type: Object,
                required: true,
            },
            isSidebarExpanded: {
                type: Boolean,
                required: true,
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/mobile/components/PrimaryNavItem.vue